import { render, staticRenderFns } from "./ProblemDetail.vue?vue&type=template&id=27258afa&scoped=true"
import script from "./ProblemDetail.vue?vue&type=script&lang=js"
export * from "./ProblemDetail.vue?vue&type=script&lang=js"
import style0 from "./ProblemDetail.vue?vue&type=style&index=0&id=27258afa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27258afa",
  null
  
)

export default component.exports